<form [formGroup]="teamForm" (ngSubmit)="save()">
  <div class="row p-4">
    <div class="col-6">
      <div class="row mb-3">
        <label [for]="'name-' + team.id" class="col-sm-5 col-form-label">{{ 'ENTITY.NAME' | translate }} *</label>
        <div class="col-sm-7">
          <!--<ng-select [id]="'teamNames'" [searchable]="true" formControlName="name" [clearable]="true" labelForId="yesno"
            placeholder="{{'USER.TEAM' | translate}}">
            <ng-option [value]="team.name" *ngFor="let team of partialTeams">{{ team.name }}</ng-option>
          </ng-select>-->
          <input type="text" class="form-control" [id]="'name-' + team.id" formControlName="name"
            [readonly]="(user.roleId === 2 && user.profileId===2) ? true : false">
          <hbo-control-messages [control]="teamForm.get('name')!" [component]="'team-actions'"
            [errorMessage]="'error'"></hbo-control-messages>
        </div>
      </div>

      <small>* {{ 'COMMON.MANDATORY' | translate }}</small>
    </div>

    <div class="col-6">
      <div *ngIf="team" class="row mb-3">
        <label *ngIf="user.roleId === 1" [for]="'entity-' + team.id" class="col-sm-5 col-form-label">{{ 'USER.ENTITY' |
          translate }} *</label>
        <div *ngIf="action !== 'create' && user.roleId === 1" class="col-sm-7 align_middle">
          {{team.entity.name}}
        </div>
        <div *ngIf="user.roleId == 1 && action === 'create' && (entity && entities.length)" class="col-sm-7">
          <!--<select [class]="action === 'detail' ? 'form-control-plaintext' : 'form-select'" [id]="'entityId-' + team.id" formControlName="entityId">
            <option [value]="entity.id" *ngFor="let entity of entities">{{ entity.name | titlecase }}</option>
          </select>
          <hbo-control-messages [control]="teamForm.get('entityId')!"></hbo-control-messages>-->
          <!--<hbo-single-select-multi-level [tree]="entities" [userEntity]="user"
            [typeData]="action === 'create' ?  'newTeam': 'team'"
            [max]="action === 'create' ? reactiveToRole : entity.entityTypeId" [selection]="entity"
            formControlName="entityId" >
          </hbo-single-select-multi-level>-->
          <app-basic-virtual-scroll *ngIf="configSvc.currentConfigValue.childEntities" [customTreeNode]="parentEntities"
            [entityId]="persistEntityId" (callback)="onChange($event,'entity')"
            [typeData]="action === 'create' ?  'newTeam': 'team'"></app-basic-virtual-scroll>
          <hbo-control-messages [control]="teamForm.get('entityId')!"></hbo-control-messages>
        </div>
      </div>
    </div>
  </div>

  <div class="p-4" *ngIf="user?.profileId !== 2 && !(user.roleId === 2 && user.profileId !== 3)">
    <button type="button" class="btn btn-outline-secondary me-2" (click)="cancel()">{{ 'COMMON.CANCEL' | translate
      }}</button>
    <button type="submit" class="btn btn-dark" [ngClass]="{'submit-pb-disabled':!teamForm.valid}">{{
      'COMMON.SAVE_CHANGES' | translate }}</button>
    <button type="button" class="btn btn-outline-secondary float-end" data-bs-toggle="modal"
      [attr.data-bs-target]="'#confirmationModal-' + team.id" *ngIf="action === 'edit'">
      <i class="bi bi-trash3"></i> {{ 'COMMON.DELETE' | translate }}
    </button>
  </div>
</form>

<hbo-confirmation-modal [id]="team.id" (confirm)="delete()"></hbo-confirmation-modal>

<hbo-confirmation-modal [id]="'team-delete'" (confirm)="utils.toogleModal('#confirmationModal-team-delete',true)"
  [hideConfirm]="true" [head]="'team in use exists'" [message]="'false'"></hbo-confirmation-modal>